import type { SettingsSectionConfig } from './settings.types';

export const SETTINGS_SECTIONS: SettingsSectionConfig[] = [
  {
    key: 'indexing',
    title: 'Indexação',
    columnLabel: 'Indexadores',
    fieldLabel: 'Indexador:',
    fieldPlaceholder: 'Informe o novo indexador',
    emptyMessage: 'Nenhum indexador cadastrado. Adicione o primeiro.',
  },
  {
    key: 'recordOrigin',
    title: 'Origem do Registro',
    columnLabel: 'Origem',
    fieldLabel: 'Origem do Registro:',
    fieldPlaceholder: 'Informe o nome da Origem',
    emptyMessage: 'Nenhuma origem cadastrada. Adicione a primeira.',
  },
  {
    key: 'recordType',
    title: 'Tipos de Registro',
    columnLabel: 'Tipos',
    fieldLabel: 'Tipo:',
    fieldPlaceholder: 'Informe o nome do Tipo de Registro',
    emptyMessage: 'Nenhum tipo de registro cadastrado. Adicione o primeiro.',
  },
  {
    key: 'protectionMeans',
    title: 'Meios de Proteção',
    columnLabel: 'Meios',
    fieldLabel: 'Meio de Proteção:',
    fieldPlaceholder: 'Informe o nome do Meio de Proteção',
    emptyMessage: 'Nenhum meio de proteção cadastrado. Adicione o primeiro.',
  },
  {
    key: 'recordStage',
    title: 'Etapas dos Registros',
    columnLabel: 'Etapas',
    fieldLabel: 'Etapas:',
    fieldPlaceholder: 'Informe o nome da Etapa do Registro',
    emptyMessage: 'Nenhuma etapa cadastrada. Adicione a primeira.',
  },
];

export const SETTINGS_ORDER_OPTIONS = [
  { label: 'Mais recente', sort: 'createdAt', order: 'desc' },
  { label: 'Mais antigo', sort: 'createdAt', order: 'asc' },
];
